module.exports = __webpack_public_path__ + "static/media/06.Traditional Bell.6ac771eb.JPG";